import React, { PropsWithChildren, useContext, useMemo, useState } from 'react';

import { createPortal } from 'react-dom';

import { getModalStackElement, ModalStack, renderStackModals } from './ModalStack';
import { ModalProps, ModalStacked, ModalStackProps } from './types';

const ModalManagerContext = React.createContext<ModalStackProps>({} as any);

export const ModalManagerProvider = ({ children }: PropsWithChildren) => {
  const [stack, setStack] = useState<ModalStacked[]>([]);

  const value = useMemo<ModalStackProps>(() => {
    function pop(amount = 1) {
      return setStack((prev) => {
        const newStack = [...prev];

        for (let i = 0; i < amount; i++) {
          const modal = newStack.pop();
          modal?.props?.onClose?.();
        }

        return newStack;
      });
    }
    return {
      stack,
      openModal: (component, props, options) => {
        setStack((prev) => {
          let newStack = [...prev];

          if (options?.replace) {
            const modal = newStack.pop();
            modal?.props?.onClose?.();
          }

          props?.onOpen?.();

          return [...newStack, { component, props: props as ModalProps } as ModalStacked];
        });
      },
      closeModal: () => pop(1),
      closeModals: pop,
      closeAllModals: () => pop(stack.length),
      renderModals: () => {
        const modals = renderStackModals(stack, false);
        const modalStackElement = getModalStackElement();

        if (!modalStackElement) {
          return null;
        }

        return createPortal(modals, modalStackElement);
      },
    };
  }, [stack]);

  return (
    <ModalManagerContext.Provider value={value}>
      {children}
      <ModalStack />
    </ModalManagerContext.Provider>
  );
};

export function useModals() {
  return useContext(ModalManagerContext);
}
